import React, {Component} from 'react';

class ProgressiveImage  extends Component {
    constructor(props) {
        super(props);
        this.state = {
            highResImageLoaded: false,
            lowResImageLoaded: false,
        };
    }

    imageLow() {
        if ( this.props.srcLow ) {
          return (
            <img
                className={`prog-img__low ${this.state.lowResImageLoaded === true ? 'prog-img__low--loaded': ''} `}
                onLoad={() => {
                    this.setState({ lowResImageLoaded: true });
                }}
                src={this.props.srcLow}
                alt={this.props.alt}
                importance="high"
            />
          );
        } else {
            return null;
        }
    }

    imageHi() {
        if ( this.props.src ) {
          return (
            <img 
                className={`prog-img__hi ${this.state.highResImageLoaded === true ? 'prog-img__hi--loaded': ''} `}
                onLoad={() => {
                    this.setState({ highResImageLoaded: true });
                }}
                ref={img => {
                    this.highResImage = img;
                }}
                src={this.props.src}
                alt={this.props.alt}
            />
          );
        } else {
            return null;
        }
    }


    render() {

        const imageHi = this.imageHi();
        const imageLow = this.imageLow();
        
        const calcProportion = {
            paddingTop: `calc(${this.props.height} / ${this.props.width} * 100%)`,
            backgroundColor: `${this.props.bgColor}`,
        }
        const wrapperStyle = { maxWidth: `${this.props.width}px` }
        
        return (
            <div className="prog-img-wrapper" style={wrapperStyle}>
                <div className={`prog-img ${this.state.highResImageLoaded === true ? 'prog-img--hi-loaded': ''} ${this.state.lowResImageLoaded === true ? 'prog-img--low-loaded': ''}`} style={calcProportion}>
                    {imageHi}
                    {imageLow}
                </div>
            </div>
        );
    }
}

export default ProgressiveImage;


// WEBPACK FOOTER //
// ./src/components/ProgressiveImage/ProgressiveImage.js